export const legalInfoTabs = {
  'zh-CN': {
    service: {
      label: '服务协议',
      content: `
        <p style="text-align: center;">
          湘楚人力资源集团有限公司服务协议
        </p>
        <p>
          <strong>【首部及导言】</strong>
        </p>
        <p>
          欢迎您使用湘楚人力资源集团有限公司的服务！
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp; 为使用湘楚人力资源集团有限公司的服务，您应当阅读并遵守《湘楚人力资源集团有限公司服务协议》（以下简称“本协议”）和《湘楚人力资源集团有限公司隐私政策》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制湘楚人力资源集团有限公司责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款（如第十八条相关约定）等，以及开通或使用某项服务的单独协议或规则。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点注意。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp; &nbsp;除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权使用湘楚人力资源集团有限公司服务。您点击“同意”或“下一步”，或您使用湘楚人力资源集团有限公司服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与湘楚人力资源集团有限公司之间产生法律效力，成为对双方均具有约束力的法律文件。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp; &nbsp;如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp; &nbsp;如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。&nbsp;</strong>
        </p>
        <p>
          &nbsp;<br>
        </p>
        <p>
          <strong>一、【协议的范围】</strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp; 1.1本协议是用户与湘楚人力资源集团有限公司之间关于其使用湘楚人力资源集团有限公司的服务所订立的协议。“湘楚人力资源集团有限公司”是指湘楚人力资源集团有限公司和/或其相关服务可能存在的运营关联单位。“用户”是指湘楚人力资源集团有限公司的服务的使用人，在本协议中更多地称为“您”。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp; 1.2湘楚人力资源集团有限公司的服务是指湘楚人力资源集团有限公司向用户提供的，包括但不限于即时通讯、网络媒体、互联网增值、互动娱乐、金融支付、广告等产品及服务，具体服务以湘楚人力资源集团有限公司实际提供的为准（以下简称“本服务”）。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp; <strong>1.3本协议内容同时包括《湘楚人力资源集团有限公司隐私政策》（链接地址http://privacy.qq.com/）,且您在使用湘楚人力资源集团有限公司某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对《湘楚人力资源集团有限公司隐私政策》的接受。</strong>
        </p>
        <p>
          <strong>二、【帐号与密码安全】</strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;2.1您在使用本服务时可能需要注册一个帐号。关于您使用帐号的具体规则，请仔细阅读并遵守相关单独协议。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;2.2湘楚人力资源集团有限公司特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。
        </p>
        <p>
          <strong>2.3为增强用户体验和/或技术便利，本服务的帐号可能包括数字、字母或者其组合，以及手机号码、电子信箱等多种形式。在您注册某一形式的帐号时，湘楚人力资源集团有限公司可能附赠该帐号的另一表现形式。具体的帐号形式、帐号体系及帐号之间的关联关系等，以湘楚人力资源集团有限公司实际提供的为准</strong>。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;2.4您在使用本服务过程中，可能可以为您使用的帐号设置昵称、头像、签名、留言等信息，也可能为您建立或者管理、参与的QQ群、微信群等设置名称、图片、简介等信息。您应当保证这些信息的内容和形式符合法律法规（本协议中的“法律法规”指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等，下同。）、公序良俗、社会公德以及湘楚人力资源集团有限公司平台规则，且不会侵害任何主体的合法权益。
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;2.5部分第三方网站或者服务可能可以用QQ帐号、微信帐号等作为其登录途径之一。您知晓，除非湘楚人力资源集团有限公司特别说明外，这些网站或者服务并非湘楚人力资源集团有限公司运营，您应自行判断此类第三方网站或者服务的安全性和可用性，并自行承担相关风险和责任。</strong>
        </p>
        <p>
          <strong>三、【用户个人信息保护】</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;3.1保护用户个人信息是湘楚人力资源集团有限公司的一项基本原则。湘楚人力资源集团有限公司将按照本协议及《湘楚人力资源集团有限公司隐私政策》（链接地址：http://privacy.qq.com/）的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《湘楚人力资源集团有限公司隐私政策》的内容为准。</strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;3.2您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;3.3一般情况下，您可根据相关产品规则浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;3.4湘楚人力资源集团有限公司将尽可能运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
        </p>
        <p>
          &nbsp; &nbsp; <strong>&nbsp;&nbsp;3.5湘楚人力资源集团有限公司不会将您的个人信息转移或披露给任何第三方，除非：</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;（1）相关法律法规或司法机关、行政机关要求。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;（2）为完成合并、分立、收购或资产转让而转移。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;（3）为提供您要求的服务所必需。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp; &nbsp;&nbsp;（4）依据《湘楚人力资源集团有限公司隐私政策》或其他相关协议规则可以转移或披露给任何第三方的情形。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>3.6湘楚人力资源集团有限公司非常重视对未成年人个人信息的保护。若您不具备完全民事行为能力，在使用湘楚人力资源集团有限公司的服务前，应事先取得您的监护人的同意。
        </p>
        <p>
          四、【使用本服务的方式】
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>4.1本服务仅为您个人非商业性质的使用，除非您与湘楚人力资源集团有限公司另有约定。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>4.2您依本协议条款所取得的权利不可转让。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>4.3您不得使用任何方式（包括但不限于第三方软件、插件、外挂、系统、设备等）对本服务进行干扰、破坏、修改或施加其他影响。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>4.4您应当通过湘楚人力资源集团有限公司提供或认可的方式使用本服务，不得通过任何第三方软件、插件、外挂、系统、设备等登录或使用本服务。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>4.5任何人未经湘楚人力资源集团有限公司授权不得使用任何第三方软件、插件、外挂、系统等查看、获取本服务中所包含的湘楚人力资源集团有限公司、湘楚人力资源集团有限公司合作伙伴或用户的任何相关信息、数据等内容，同时，应当严格遵守湘楚人力资源集团有限公司发布的Robots协议等相关协议规则。
        </p>
        <p>
          <strong>五、【按现状提供服务】</strong>
        </p>
        <p>
          <strong>您理解并同意：</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>5.1本服务是按照现有技术和条件所能达到的现状提供的。湘楚人力资源集团有限公司会尽最大努力保障服务的连贯性和安全性，但湘楚人力资源集团有限公司不能随时预见和防范法律、技术以及其他风险，湘楚人力资源集团有限公司对此类风险在法律允许的范围内免责，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp;&nbsp; &nbsp;&nbsp;</strong>5.2因经营策略安排或调整等原因,不同地区的用户可使用的具体湘楚人力资源集团有限公司服务的内容可能会存在差异，具体以湘楚人力资源集团有限公司实际提供的为准。</strong>
        </p>
        <p>
          <strong>六、【自备设备】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>6.1您应当理解，您使用本服务需自行准备与相关服务有关的终端设备（如电脑、移动终端和必要的网络接入设备等装置），并承担所需的费用（如电话费、上网费等费用）。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>6.2您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。
        </p>
        <p>
          <strong>七、【广告】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>7.1您同意湘楚人力资源集团有限公司可以自行或由第三方通过短信、电子邮件或电子信息等多种方式向您发送、展示广告或其他信息（包括商业与非商业信息），广告或其他信息的具体发送及展示形式、频次及内容等以湘楚人力资源集团有限公司实际提供为准。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>7.2湘楚人力资源集团有限公司将依照相关法律法规要求开展广告业务。您同意，对本服务中出现的广告，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对因该广告而实施的行为负责。</strong>
        </p>
        <p>
          <strong>八、【服务费用】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>8.1湘楚人力资源集团有限公司的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>8.2湘楚人力资源集团有限公司可能根据实际需要对收费服务的收费标准、方式进行修改和变更，湘楚人力资源集团有限公司也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，湘楚人力资源集团有限公司将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>8.3在湘楚人力资源集团有限公司降低收费服务的收费标准或者将收费服务改为免费服务提供时，湘楚人力资源集团有限公司保留不对原付费用户提供退费或者费用调整之权利。</strong>
        </p>
        <p>
          <strong>九、【第三方提供的产品或服务】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>您在湘楚人力资源集团有限公司平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。湘楚人力资源集团有限公司和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</strong>
        </p>
        <p>
          <strong>十、【基于软件提供服务】</strong>
        </p>
        <p>
          若湘楚人力资源集团有限公司依托“软件”向您提供服务，您还应遵守以下约定：
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>10.1您在使用本服务的过程中可能需要下载软件，对于这些软件，湘楚人力资源集团有限公司给予您一项个人的、不可转让及非排他性的许可。您仅可为使用本服务的目的而使用这些软件。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>10.2为了改善用户体验、保障服务的安全性及产品功能的一致性等目的，湘楚人力资源集团有限公司可能会对软件进行更新。您应该将相关软件更新到最新版本，否则湘楚人力资源集团有限公司并不保证软件或服务能正常使用。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>10.3湘楚人力资源集团有限公司可能为不同的终端设备开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。您可以直接从湘楚人力资源集团有限公司平台上获取软件，也可以从得到湘楚人力资源集团有限公司授权的第三方获取。如果您从未经湘楚人力资源集团有限公司授权的第三方获取软件或与软件名称相同的安装程序，湘楚人力资源集团有限公司无法保证该软件或服务能够正常使用，并对因此给您造成的损失不予负责。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong><strong>10.4除非湘楚人力资源集团有限公司书面许可，您不得从事下列任一行为：</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（1）删除软件及其副本上关于著作权的信息。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（3）对湘楚人力资源集团有限公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经湘楚人力资源集团有限公司授权的第三方工具/服务接入软件和相关系统。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（5）通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（6）通过非湘楚人力资源集团有限公司开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用湘楚人力资源集团有限公司软件及服务，或制作、发布、传播非湘楚人力资源集团有限公司开发、授权的用于登录或使用湘楚人力资源集团有限公司软件及服务的第三方软件、插件、外挂、系统、设备等。
        </p>
        <p>
          <strong>十一、【知识产权声明】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>11.1湘楚人力资源集团有限公司在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归湘楚人力资源集团有限公司所有，用户在使用本服务中所产生内容的知识产权归用户或相关权利人所有，除非您与湘楚人力资源集团有限公司另有约定。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>11.2除另有特别声明外，湘楚人力资源集团有限公司提供本服务时所依托软件的著作权、专利权及其他知识产权均归湘楚人力资源集团有限公司所有。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>11.3湘楚人力资源集团有限公司在本服务中所使用的“QQ”、“湘楚人力资源集团有限公司”、“TENCENT”及企鹅形象等商业标识，其著作权或商标权归湘楚人力资源集团有限公司所有。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>11.4上述及其他任何本服务包含的内容的知识产权均受到法律法规保护，未经湘楚人力资源集团有限公司、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
        </p>
        <p>
          <strong>十二、【用户违法违规行为】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>12.1您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（1）反对宪法所确定的基本原则的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（3）损害国家荣誉和利益的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（4）煽动民族仇恨、民族歧视，破坏民族团结的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（5）破坏国家宗教政策，宣扬邪教和封建迷信的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（6）散布谣言，扰乱社会秩序，破坏社会稳定的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（8）侮辱或者诽谤他人，侵害他人合法权益的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（9）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>（10）相关法律法规或本协议、相关协议、规则等禁止的。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>12.2如果您在使用本服务过程中违反了相关法律法规或本协议约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求湘楚人力资源集团有限公司给予协助。<strong>因此给您或者他人造成损害的，您应自行承担全部责任，湘楚人力资源集团有限公司不承担任何责任。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp; &nbsp;</strong>12.3如果您违反本协议约定，湘楚人力资源集团有限公司有权进行独立判断并采取相应措施，包括但不限于通过技术手段删除、屏蔽相关内容或断开链接等。同时，湘楚人力资源集团有限公司有权视用户的行为性质，采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对QQ帐号、微信帐号的使用，追究法律责任等措施。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp; </strong>&nbsp;12.4您违反本协议约定，导致任何主体损失的，您应当独立承担责任；湘楚人力资源集团有限公司因此遭受损失的，您也应当一并赔偿。
        </p>
        <p>
          <strong>十三、【遵守当地法律监管】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>13.1您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。<strong>如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>13.2您应避免因使用本服务而使湘楚人力资源集团有限公司违反法律法规或卷入政治和公共事件，否则湘楚人力资源集团有限公司有权暂停或终止对您的服务。</strong>
        </p>
        <p>
          <strong>十四、【用户发送、传播的内容与投诉处理】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>14.1您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>14.2您发送或传播的内容应有合法来源，相关内容为您所有或您已获得必要的授权。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>14.3如果您发送或传播的内容违法违规或侵犯他人权利的，湘楚人力资源集团有限公司有权进行独立判断并采取删除、屏蔽或断开链接等措施。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>14.4如您被他人投诉或您投诉他人，湘楚人力资源集团有限公司有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>14.5您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。</strong>
        </p>
        <p>
          <strong>十五、【不可抗力及其他免责事由】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>15.1您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，湘楚人力资源集团有限公司将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失湘楚人力资源集团有限公司在法律允许的范围内免责。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>15.2在法律允许的范围内，湘楚人力资源集团有限公司对以下情形导致的服务中断或受阻不承担责任：</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（2）用户或湘楚人力资源集团有限公司的电脑软件、系统、硬件和通信线路出现故障。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（3）用户操作不当或用户通过非湘楚人力资源集团有限公司授权的方式使用本服务。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（4）程序版本过时、设备的老化和/或其兼容性问题。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（5）其他湘楚人力资源集团有限公司无法控制或合理预见的情形。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>15.3您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，湘楚人力资源集团有限公司不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（2）遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（3）其他因网络信息或用户行为引起的风险。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>15.4湘楚人力资源集团有限公司依据本协议约定获得处理违法违规内容的权利，该权利不构成湘楚人力资源集团有限公司的义务或承诺，湘楚人力资源集团有限公司不能保证及时发现违法行为或进行相应处理。</strong>
        </p>
        <p>
          <strong>15.5在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。涉及财产操作的，请一定先核实对方身份，并请经常留意湘楚人力资源集团有限公司有关防范诈骗犯罪的提示。</strong>
        </p>
        <p>
          <strong>十六、【协议的生效与变更】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>16.1您使用本服务即视为您已阅读本协议并接受本协议的约束。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>16.2湘楚人力资源集团有限公司有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>16.3本协议条款变更后，如果您继续使用湘楚人力资源集团有限公司提供的软件或服务，即视为您已接受变更后的协议。</strong>
        </p>
        <p>
          <strong>十七、【服务的变更、中断、终止】</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>17.1您理解并同意，湘楚人力资源集团有限公司基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>17.2在湘楚人力资源集团有限公司发生合并、分立、收购、资产转让时，湘楚人力资源集团有限公司可向第三方转让本服务下相关资产；湘楚人力资源集团有限公司也可在单方通知您后，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。具体受让主体以湘楚人力资源集团有限公司通知的为准。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>17.3如发生下列任何一种情形，湘楚人力资源集团有限公司有权不经通知而中断或终止向您提供服务：</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（1）根据法律法规规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（2）您违反相关法律法规的规定或违反本协议的约定。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（3）按照法律法规规定，司法机关或主管部门的要求。</strong>
        </p>
        <p>
          <strong><strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（4）出于安全的原因或其他必要的情形。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>17.4湘楚人力资源集团有限公司有权按本协议8.2条的约定进行收费。若您未按时足额付费，湘楚人力资源集团有限公司有权中断、中止或终止提供服务。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>17.5您有责任自行备份存储在本服务中的数据。如果您的服务被终止，湘楚人力资源集团有限公司有权从服务器上永久地删除您的数据,法律法规另有规定的除外。服务中止或终止后，湘楚人力资源集团有限公司没有义务向您提供或返还数据。
        </p>
        <p>
          <strong>十八、【管辖与法律适用】</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp;&nbsp;18.1本协议的成立、生效、履行、解释及纠纷解决等相关事宜，均适用中华人民共和国大陆地区法律（不包括冲突法）。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp;&nbsp;18.2本协议签订地为中华人民共和国广东省深圳市南山区。</strong>
        </p>
        <p>
          <strong>&nbsp; &nbsp;&nbsp;18.3若您和湘楚人力资源集团有限公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地（即中国广东省深圳市南山区）有管辖权的人民法院管辖。</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>18.4本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>18.5本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>18.6若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。
        </p>
        <p>
          <strong>十九、【未成年人使用条款】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>19.1若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>19.2未成年人用户涉世未深，容易被网络虚像迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护：
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（3）在监护人或老师的指导下，学习正确使用网络。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>（4）避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>19.3监护人、学校均应对未成年人使用本服务多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>19.4已满18周岁的成年人因任何原因不具备完全民事行为能力的，参照适用本协议之未成年人使用条款之相关约定。
        </p>
        <p>
          <strong>二十、【其他】</strong>
        </p>
        <p>
          <strong style="white-space: normal;">&nbsp; &nbsp;&nbsp;</strong>20.1如果您对本协议或本服务有意见或建议，可与湘楚人力资源集团有限公司客户服务部门联系（kf.qq.com），我们会给予您必要的帮助。（正文完）
        </p>
        <p>
          <br>
        </p>
        <p>
          湘楚人力资源集团有限公司公司
        </p>
        <p>
          <br>
        </p>
      `
    },
    privacy: {
      label: '隐私政策',
      content: `
        <div class="PrivacyBox">
          <h2 class="title title1">法律声明及隐私条款</h2>
          <h4 class="title">提示条款</h4>
          <p class="texts">湘楚人力资源集团有限公司(以下简称湘楚人力)提醒您：在使用湘楚人力平台各项服务前，请您务必仔细阅读并透彻理解本《法律声明及隐私权政策》（下称“本声明”）。如对本声明内容有任何疑问，您可通过发邮件至marketing@湘楚人力.com与我们联系。当您使用湘楚人力平台提供的任一服务时，即表示您已同意并认可本声明的全部内容。如果您不同意本声明或其中任何内容，您应立即停止使用湘楚人力平台服务。如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</p>
          <h4 class="title">法律声明</h4>
          <h3 class="titles">权利归属</h3>
          <p class="texts">除非湘楚人力另行声明，湘楚人力平台内的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密及其他所有相关权利）均归湘楚人力或其关联公司所有。未经湘楚人力许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载湘楚人力平台内的任何内容）。</p>
          <p class="texts">湘楚人力平台的Logo、“湘楚人力”等文字、图形及其组合，以及湘楚人力平台的其他标识、徵记、产品和服务名称均为湘楚人力及其关联公司在中国和其它国家的商标，未经湘楚人力书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。</p>
          <h3 class="titles">责任限制</h3>
          <p class="texts">鉴于湘楚人力平台提供的服务属于平台性质，湘楚人力平台上的公司主页、产品、服务、解决方案信息（包括但不限于公司主页名称、公司名称、联系人及联络信息、产品的描述和说明、相关图片、视频等）均由供应商或会员自行提供并上传，由相应的上传组织和个人对其提供并上传的所有信息承担相应法律责任。</p>
          <p class="texts">湘楚人力平台转载作品（包括论坛内容）出于传递更多信息之目的，并不意味湘楚人力赞同其观点或已经证实其内容的真实性。湘楚人力全部内容仅供参考，请正确理解和借鉴本网站相关内容。任何情况下，任何单位或个人对于因使用或转引本网站信息而导致的任何损失，均应自行承担，与本公司及本网站无关。</p>
          <h3 class="titles">知识产权保护</h3>
          <p class="texts">湘楚人力尊重知识产权，反对侵权盗版行为。知识产权权利人认为湘楚人力平台内容（包括但不限于湘楚人力平台会员发布的商品信息）可能涉嫌侵犯其合法权益，可以通过发送邮件至<b>gossliu@foxmail.com</b>提出书面通知，湘楚人力收到后将及时处理。</p>
          <h4 class="title">隐私权政策</h4>
          <p class="texts">湘楚人力（或称“我们”）尊重并保护用户隐私，在您使用湘楚人力平台提供的服务时，我们将按照本隐私权政策（或称“本政策”）收集、使用及共享您的个人信息。本隐私权政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，我们希望通过本隐私权政策向您清晰地介绍我们对您个人信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式，同时更好地了解我们的服务并作出适当的选择。</p>
          <p class="texts">本隐私政策主要向您说明：<br>我们收集哪些信息；<br>我们收集信息的用途；<br>您所享有的权利。</p>
          <p class="texts underline">请在使用我们的服务前，仔细阅读并了解本隐私政策。当您使用湘楚人力平台提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。</p>
          <h3 class="titles">适用范围</h3>
          <p class="texts">为用户提供更好、更优、更个性化的服务是湘楚人力坚持不懈的追求，也希望通过我们提供的服务可以更方便您的生活。本隐私权政策适用于湘楚人力平台提供的所有服务，您访问湘楚人力平台及未设独立隐私权政策的关联公司网站及/或登录相关客户端使用湘楚人力平台提供的服务，均适用本隐私权政策。</p>
          <p class="texts">需要特别说明的是，本隐私权政策不适用于其他第三方向您提供的服务，例如湘楚人力上的供应商（卖家）依托湘楚人力平台向您提供服务时，您向其提供的个人信息不适用于本隐私权政策。您使用该等第三方服务须受其隐私权政策（而非本政策）约束，您需要仔细阅读其政策内容。</p>
          <h3 class="titles">我们收集哪些信息</h3>
          <p class="texts">为了向您提供更好、更优、更个性化的服务，我们根据合法、正当、必要的原则，仅根据您使用的服务收集您的如下信息：</p>
          <p class="texts">1.您向我们提供的信息</p>
          <p class="texts">1.1 当您在湘楚人力平台创建账户时填写的信息。<br>例如，您在创建账户时所填写的会员名、电话号码及/或电子邮箱等信息。</p>
          <p class="texts">1.2 您在使用湘楚人力平台服务时上传的信息。<br>例如，您选择填写及/或提交服务所必须的信息，可能包括您的姓名、性别、公司、职位、护照姓、护照名、电话号码、电子邮箱、地址、手机及相关附加信息（如您所在的省份和城市、邮政编码等）。我们的部分服务可能需要您的前述信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。如果您不使用某些服务，则无需提供相关信息。<b>若您主动提供您的签署信息，即表示您同意我们按本政策所述目的和方式来处理您的信息。</b></p>
          <p class="texts">1.3 您通过我们的客服或使用我们的服务时提供的信息。<br>例如，您在湘楚人力发布的信息、搜索关键词信息、与湘楚人力客服联系时您提供的相关信息、您参与问卷调查时向我们发送的问卷答复信息等。</p>
          <p class="texts">2.我们在您使用服务过程中收集的信息</p>
          <p class="texts">我们会根据您授予的权限，接收并记录您所使用的设备相关信息，这些设备信息包括：设备属性信息（如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备位置信息（如通过GPS、蓝牙或WIFI信号获得的位置信息）、设备连接信息（IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您需求的网页记录等）。</p>
          <p class="texts">对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。</p>
          <p class="texts">此外，为提高您使用湘楚人力平台提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能根据您的授权，通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</p>
          <p class="texts">3.来自第三方的信息</p>
          <p class="texts">当您与使用我们服务的关联公司、湘楚人力合作伙伴之间互动时，为共同向您提供服务及改进服务质量的合理需要，我们将从关联公司、合作伙伴处接收关于您的体验或您与其互动的信息。</p>
          <p class="texts">为预防欺诈和确保安全，湘楚人力的关联公司、合作伙伴会依据适用的法律法规或征得您同意的前提下，向我们分享您的信息。</p>
          <p class="texts">除通过上述渠道收集的信息外，请您不要主动提供除接受服务需要提供外的其他个人敏感信息（如种族、宗教、政治立场等），该等信息有被意外收集的可能性。</p>
          <h3 class="titles">我们如何使用收集到的信息</h3>
          <p class="texts">收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会严格遵守法律法规的规定及与您的约定，将收集的信息用于下列用途。我们通过技术手段对数据进行去标识化处理后，有权在不透露个人信息的前提下对该等数据进行商业化利用。在上述信息处理活动中，我们将全面遵守各项法律义务。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</p>
          <p class="texts">1.向您提供您使用的各项服务，并维护、改进这些服务。</p>
          <p class="texts">2.向您推荐您可能感兴趣的内容，包括但不限于向您发出产品和服务信息，或通过系统向您展示个性化的第三方推广信息，或者在征得您同意的情况下与湘楚人力的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。如您不希望接收上述信息，可通过相应的退订功能进行退订。</p>
          <p class="texts">3.我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、我们的其他用户、我们或我们关联方的合法权益。</p>
          <p class="texts">4.我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。</p>
          <p class="texts">5.经您许可的其他用途。</p>
          <h3 class="titles">您的权利——您如何管理自己的信息</h3>
          <p class="texts">我们提供了便捷的方法，让您可以查询、更正及删除自己的账户信息等使用我们服务时您提供的个人信息。例如您可以登录“用户中心”修改自己的个人资料、隐私设置、安全设置，删除您的收货地址、交易订单、活动注册等信息或注销您的湘楚人力账户，获取您提供的个人信息副本、或者撤回您对个人信息使用的同意、限制我们对您的个人信息数据处理活动。</p>
          <p class="texts">在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。</p>
          <p class="texts">您可通过本政策末尾所列的联系方式与我们联系行使上述权利，但您同时了解，我们可能拥有其他法律依据处理您已经提供的个人信息数据。</p>
          <p class="texts"><b>我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。</b>如果您认为湘楚人力存在违反法律、行政法规的规定或者与您的约定收集、使用您个人信息的，您可以要求我们删除。如果您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。您可以通过本政策列明的方式与我们取得联系。</p>
          <p class="texts">请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</p>
          <p class="texts"><b>您共享的信息</b><br>您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</p>
          <p class="texts">在使用湘楚人力平台服务进行网上交易或注册由第三方发布在湘楚人力的活动时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如个人商务联系信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即联络湘楚人力客服，以便湘楚人力采取相应措施。</p>
          <p class="texts">公开信息是指您公开分享的任何信息。任何人都可以在使用和未使用湘楚人力期间查看或访问这些信息。例如当您在湘楚人力平台进行交易，不选择“匿名购买”和/或“匿名评价”功能时，意味着您将公开分享您的成交价、成交信息及评价详情等数据。</p>
          <p class="texts">为使用湘楚人力服务，可能存在您必须公开分享的信息。例如为构建诚信交易环境，您的信用评价信息需要被公开分享。若您是供应商工作人员，您应当根据适用的法律法规和湘楚人力规则的要求，公开分享企业名称等相关工商注册信息或者自然人经营者的信息。</p>
          <p class="texts"><b>请注意，您在使用我们服务时自愿共享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</b></p>
          <h3 class="titles">我们如何共享信息</h3>
          <p class="texts">我们对您的信息承担保密义务，不会出于第三方的营销目的而向其出售或提供您的任何信息，除下列情形外，我们不会与任何其他第三方共享您的个人信息：</p>
          <p class="texts"><b>1、您在湘楚人力注册参加第三方发布于湘楚人力的活动，下载第三方上传或观看于湘楚人力的文件/视频（一般该文件通过注册表单方式进行下载）、向第三方提交购买或合作需求。在您通过表单注册发布于湘楚人力网站的各种活动后，表示您同意并授权该活动主办方及该活动的参展/赞助商（若有）可以获取您的注册信息，并与您进行商务合作方面的联系。</b></p>
          <p class="texts">我们将会分享您的信息，但仅限于您任职的公司名称、您所留公司邮箱及座机、您的姓名及职位。其余信息一概不会对任何第三方分享。</p>
          <p class="texts">2.事先获得授权。获得您的明确同意后，我们会与其他公司、组织和个人分享您的个人信息。</p>
          <p class="texts">3.与湘楚人力关联公司共享。事先征得您的明确同意和授权后向湘楚人力的关联公司分享您的个人信息。我们只会共享必要的个人信息，且受本隐私权政策中所声明目的的约束。</p>
          <p class="texts">湘楚人力的关联公司包括：深圳河马大数据人力资源有限公司。</p>
          <p class="texts">4.出于法律原因。为遵守适用的法律法规、诉讼目的或者行政机关、司法机构依法提出的要求，我们可能有必要披露您的个人信息。如果我们确定您出现违反适用的法律法规或湘楚人力规则或相关协议的情况，或为保护湘楚人力及其关联公司或用户或公众的权利、财产或安全免遭损害，我们也可能披露关于您的信息，包括相关违规行为以及湘楚人力已对您采取的措施。</p>
          <p class="texts">5.事先征得您的同意和授权后用于外部处理。仅为实现本隐私权政策中声明的目的，我们可能让可信赖的合作伙伴作为数据处理者，根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>
          <p class="texts">目前，我们的授权合作伙伴主要为供应商、服务提供商类合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商合作伙伴，这些支持包括提供技术支持服务（如EDM服务）等。</p>
          <p class="texts">对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私权政策以及其它任何相关的保密和保全措施来处理个人信息。</p>
          <p class="texts">6.事先征得您的同意和授权后协助解决争议。某些情况下只有共享您的信息，才能处理您与他人的纠纷或争议。例如您是适格的知识产权投诉人并已提起投诉，我们可能应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；您在湘楚人力上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，湘楚人力会视情况向该用户提供其交易对方的联络方式等必要信息，以促成纠纷的解决。</p>
          <p class="texts">7.在您向我们发出撤回同意分享的申请时，我们会无条件立即停止该等信息的共享，但该等申请发出前已经共享的部分除外。如果我们使用您的个人信息超出了与收集时所声明的目的，我们将在使用前再次向你告知并征得你的明示同意。</p>
          <h3 class="titles">我们如何使用Cookie</h3>
          <p class="texts">为确保网站正常运转，同时使您获得更轻松的访问体验，您访问湘楚人力平台相关网站或使用湘楚人力平台提供的服务时，我们可能会通过采用各种技术收集和存储相关信息，包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</p>
          <p class="texts">请您理解，我们的某些服务只能通过使用Cookie才可得到实现。我们不会将Cookie用于本政策所述目的之外的任何用途。您可以根据自己的偏好管理或删除Cookie。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝湘楚人力的Cookie，但拒绝湘楚人力的Cookie在某些情况下可能会影响您安全访问湘楚人力平台相关网站和使用湘楚人力平台提供的服务。</p>
          <h3 class="titles">我们如何存留信息</h3>
          <p class="texts">湘楚人力收集的有关您的信息和资料将保存在湘楚人力及（或）其关联公司的服务器上，在中华人民共和国境内收集和产生的个人信息，将储存在中华人民共和国境内。这些信息和资料可能传送至您所在国家、地区或湘楚人力收集信息和资料所在地并在该地被访问、存储和展示。不同国家、地区可能设有不同的数据保护法，在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。</p>
          <p class="texts">我们仅为实现本隐私权政策中所述目的所必需的期间内保留您的个人信息，但在但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
          <p class="texts">● 为遵守适用的法律法规等有关规定；<br>● 为遵守法院判决、裁定或其他法律程序的规定；<br>● 为遵守相关政府机关或法定授权组织的要求；<br>● 我们有理由确信需要遵守法律法规等有关规定；<br>● 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
          <p class="texts">当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</p>
          <p class="texts">除本政策述明的情况和法律法规规定的例外情况外，我们不会向任何第三方出售、或提供任何用户个人信息。</p>
          <h3 class="titles">我们如何保护您的个人信息</h3>
          <p class="texts">1、湘楚人力非常重视您的个人信息安全。我们努力采取各种合理的物理、电子和管理方面的符合业界标准的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于部署信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况、举办安全和隐私保护培训课程加强员工对于保护个人信息重要性的认识等措施。</p>
          <p class="texts">2、我们会采取一切合理可行的措施，确保未手机无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
          <p class="texts">3、互联网并非绝对安全的环境，且电子邮件、即时通讯及与其他湘楚人力用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。湘楚人力账户信息（包括账号名及密码信息）为非常重要的个人信息，请您妥善设置、保管您的湘楚人力账号名及密码信息。请使用复杂密码，协助我们保证您的账号安全。湘楚人力将通过备份、对密码进行加密等安全措施以保护您的账户信息等个人信息不丢失、不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</p>
          <p class="texts">请注意，单独的设备信息、搜索关键词信息等是无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将这类非个人信息与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类设备信息将被视为个人信息。</p>
          <p class="texts">4、若不幸发生个人信息泄露等安全事件，我们将按照法律法规的要求，及时向您告知，并启动应急预案，阻止安全事件扩大。我们将以推送通知、公告等形式告知您事件相关情况。</p>
          <h3 class="titles">未成年人保护</h3>
          <p class="texts">我们的产品、网站和服务主要面向成人。我们非常重视未成年人的个人信息保护，并不试图收集未成年人信息。如您为18周岁以下的未成年人，应在您的监护人仔细阅读本隐私权政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时或未成年人在未取得您同意的情况下向我们提供了个人信息，请通过本政策末尾所示联系方式与我们联系。</p>
          <h3 class="titles">本政策的修订</h3>
          <p class="texts">本政策受中华人民共和国法律管辖，如其内容与相关法律规定相抵触，应以法律规定为准。本政策为可分割的，被判决或裁定为无效的内容不影响其他内容的有效性。本政策最后更新于2018年9月21日。我们可能会不定期修改本《法律声明及隐私权政策》，变更后的《法律声明及隐私权政策》将在修订生效前通过湘楚人力平台公告或以其他适当方式通知您。也请您访问<a href="#" target="_blank" class="underline">湘楚人力隐私政策</a>以便及时了解最新的隐私政策。该等情况下，若您继续使用我们的服务，即表示同意受经修订的《法律声明及隐私权政策》的约束。</p>
          <p class="texts">对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私权政策的具体变更内容）。</p>
          <h3 class="titles">如何联系我们</h3>
          <p class="texts">若您对本隐私权政策有任何疑问、意见、建议或投诉，请通过以下方式与我们联系。一般情况下，我们将在确认您的身份后十五个工作日内回复。</p>
          <p class="texts">电话：40088-18590<br></p>
        </div>
      `
    }
  },
  en: {
    service: {
      label: 'Service Agreement',
      content: `
        <p style="text-align: center;">Service Agreement of Xiangchu Human Resources Group Co., Ltd.</p>
        <p><strong>Preamble and Introduction</strong></p>
        <p>Welcome to use the services of Xiangchu Human Resources Group Co., Ltd.!</p>
        <p>In order to use the services of Xiangchu Human Resources Group Co., Ltd. (hereinafter referred to as “Xiangchu” or “the Company”), you shall read and comply with the Service Agreement of Xiangchu Human Resources Group Co., Ltd. (hereinafter referred to as “this Agreement”) and the Privacy Policy of Xiangchu Human Resources Group Co., Ltd.. Please carefully read and fully understand all terms herein, especially those clauses that exempt or limit the liability of Xiangchu, restrict user rights, or stipulate dispute resolution methods and jurisdiction (such as Article 18), as well as any separate agreements or rules applicable to specific services.</p>
        <p>Clauses concerning limitations of liability or significant rights may be highlighted in bold or underlined for your attention.</p>
        <p>Unless you have fully read, understood, and accepted all terms of this Agreement, you shall have no right to use Xiangchu’s services. By clicking “Agree” or “Next”, or by using the services, or by any other express or implied means of acceptance, you shall be deemed to have read and agreed to this Agreement. This Agreement shall then become legally binding upon both you and Xiangchu.</p>
        <p>If you lack full civil capacity due to age or other reasons, you shall read and decide whether to accept this Agreement under the supervision of your legal guardian.</p>
        <p>If you are located outside Mainland China, you shall also comply with the laws and regulations of your jurisdiction.</p>
        <p><strong>1. Scope of the Agreement</strong></p>
        <p>1.1 This Agreement is entered into between you and Xiangchu regarding your use of its services.</p>
        <p>1.2 The “Services” refer to all products and services provided by Xiangchu, including but not limited to instant messaging, online media, internet value-added services, entertainment, financial payment, and advertising.</p>
        <p>1.3 This Agreement includes the Privacy Policy and any separate agreements. Acceptance of any such agreement constitutes acceptance of this Agreement as a whole.</p>
        <p><strong>2. Account and Password Security</strong></p>
        <p>2.1 You may need to register an account to use the Services.</p>
        <p>2.2 You shall properly safeguard your account and password and bear all consequences of improper management.</p>
        <p>2.3 Accounts may take various forms (e.g., phone number, email, etc.), and multiple representations may be associated.</p>
        <p>2.4 You must ensure that any profile information or content complies with applicable laws and does not infringe third-party rights.</p>
        <p>2.5 Third-party services using Xiangchu accounts are not operated by Xiangchu unless otherwise stated.</p>
        <p><strong>3. Protection of Personal Information</strong></p>
        <p>3.1 Xiangchu prioritizes the protection of user personal information and processes it in accordance with this Agreement and the Privacy Policy.</p>
        <p>3.2 You may be required to provide true and complete information.</p>
        <p>3.3 Certain information may not be modifiable for security reasons.</p>
        <p>3.4 Xiangchu will adopt reasonable measures to protect your information.</p>
        <p>3.5 Personal information will not be disclosed except under legal or necessary circumstances.</p>
        <p>3.6 Special protection is provided for minors’ information.</p>
        <p><strong>4. Use of the Services</strong></p>
        <p>4.1 The Services are for personal, non-commercial use unless otherwise agreed.</p>
        <p>4.2 Rights granted under this Agreement are non-transferable.</p>
        <p>4.3 You shall not interfere with or damage the Services using unauthorized means.</p>
        <p>4.4 You must access the Services through authorized methods only.</p>
        <p>4.5 Unauthorized data extraction or crawling is prohibited.</p>
        <p><strong>5. Services Provided “As Is”</strong></p>
        <p>5.1 The Services are provided based on current technology. Xiangchu does not guarantee uninterrupted or error-free services and shall not be liable for force majeure or other risks.</p>
        <p>5.2 Service availability may vary by region.</p>
        <p><strong>6. User Equipment</strong></p>
        <p>6.1 You are responsible for preparing necessary devices and network access.</p>
        <p>6.2 Use of the Services consumes your device and network resources.</p>
        <p><strong>7. Advertising</strong></p>
        <p>7.1 Xiangchu may send advertisements or information via various channels.</p>
        <p>7.2 You shall independently assess the authenticity and reliability of advertisements.</p>
        <p><strong>8. Service Fees</strong></p>
        <p>8.1 Certain services may be paid services.</p>
        <p>8.2 Xiangchu may modify fees or introduce charges.</p>
        <p>8.3 No refund obligation exists when services become free or prices decrease.</p>
        <p><strong>9. Third-Party Services</strong></p>
        <p>You must comply with third-party agreements when using third-party services. Xiangchu and third parties bear responsibilities separately.</p>
        <p><strong>10. Software-Based Services</strong></p>
        <p>10.1 Xiangchu grants a limited, non-transferable license to use software.</p>
        <p>10.2 Updates may be required for proper functioning.</p>
        <p>10.3 Software must be obtained from authorized sources.</p>
        <p>10.4 Reverse engineering and unauthorized use are prohibited.</p>
        <p><strong>11. Intellectual Property</strong></p>
        <p>11.1 All content provided by Xiangchu is protected by intellectual property laws.</p>
        <p>11.2 Software-related rights belong to Xiangchu.</p>
        <p>11.3 Trademarks such as “QQ”, “TENCENT”, etc., are owned by Xiangchu.</p>
        <p>11.4 Unauthorized use is prohibited.</p>
        <p><strong>12. User Conduct</strong></p>
        <p>12.1 You shall not engage in illegal or prohibited activities, including but not limited to:</p>
        <p>Endangering national security</p>
        <p>Spreading illegal or harmful content</p>
        <p>Infringing others’ rights</p>
        <p>12.2 Violations may result in legal action.</p>
        <p>12.3 Xiangchu may take measures such as suspension or termination of services.</p>
        <p>12.4 You shall bear liability for damages caused.</p>
        <p><strong>13. Compliance with Local Laws</strong></p>
        <p>13.1 You must comply with applicable local laws and customs.</p>
        <p>13.2 Xiangchu may suspend services if necessary.</p>
        <p><strong>14. User Content and Complaints</strong></p>
        <p>14.1 You are responsible for content you publish.</p>
        <p>14.2 Content must be legally obtained.</p>
        <p>14.3 Xiangchu may remove unlawful content.</p>
        <p>14.4 Complaint-related information may be shared with relevant parties.</p>
        <p>14.5 You guarantee authenticity of submitted materials.</p>
        <p><strong>15. Force Majeure and Disclaimer</strong></p>
        <p>15.1 Xiangchu is not liable for force majeure events.</p>
        <p>15.2 Xiangchu is not responsible for interruptions caused by external factors.</p>
        <p>15.3 Risks from online information are borne by users.</p>
        <p>15.4 Xiangchu has the right, not obligation, to handle violations.</p>
        <p>15.5 Users should beware of fraud.</p>
        <p><strong>16. Effectiveness and Modification</strong></p>
        <p>16.1 Use of the Services constitutes acceptance of this Agreement.</p>
        <p>16.2 Xiangchu may amend this Agreement.</p>
        <p>16.3 Continued use implies acceptance of modifications.</p>
        <p><strong>17. Modification, Suspension, and Termination</strong></p>
        <p>17.1 Xiangchu may modify or terminate services.</p>
        <p>17.2 Rights and obligations may be transferred in corporate transactions.</p>
        <p>17.3 Services may be terminated under specific conditions.</p>
        <p>17.4 Non-payment may result in suspension.</p>
        <p>17.5 Data may be deleted after termination.</p>
        <p><strong>18. Governing Law and Jurisdiction</strong></p>
        <p>18.1 This Agreement is governed by the laws of Mainland China.</p>
        <p>18.2 Place of signing: Nanshan District, Shenzhen.</p>
        <p>18.3 Disputes shall be resolved through negotiation or litigation in the competent court of Shenzhen.</p>
        <p>18.4 Headings are for reference only.</p>
        <p>18.5 Invalid provisions do not affect the validity of others.</p>
        <p>18.6 Chinese version prevails in case of inconsistency.</p>
        <p><strong>19. Terms for Minors</strong></p>
        <p>19.1 Minors must use services under guardian supervision.</p>
        <p>19.2 Minors should enhance safety awareness.</p>
        <p>19.3 Guardians should provide guidance.</p>
        <p>19.4 Adults lacking capacity shall follow similar provisions.</p>
        <p><strong>20. Miscellaneous</strong></p>
        <p>If you have any questions or suggestions, please contact customer service.</p>
        <p>Xiangchu Human Resources Group Co., Ltd.</p>
      `
    },
    privacy: {
      label: 'Privacy Policy',
      content: `
        <div class="PrivacyBox">
          <h2 class="title title1">Legal Statement and Privacy Policy</h2>
          <h4 class="title">Important Notice</h4>
          <p class="texts">Xiangchu Human Resources Group Co., Ltd. (hereinafter referred to as “Xiangchu” or “we”) hereby reminds you to carefully read and fully understand this Legal Statement and Privacy Policy (hereinafter referred to as “this Policy”) before using any services provided through the Xiangchu platform.</p>
          <p class="texts">If you have any questions regarding this Policy, please contact us at: marketing@湘楚人力.com.</p>
          <p class="texts">By using any services provided by the Xiangchu platform, you acknowledge that you have read, understood, and agreed to all terms of this Policy. If you do not agree with this Policy or any part thereof, you must immediately cease using the Xiangchu platform services.</p>
          <p class="texts">If you are under 18 years of age, please read this Policy under the supervision of your legal guardian and pay special attention to provisions concerning minors.</p>
          <h4 class="title">Legal Statement</h4>
          <h3 class="titles">Ownership of Rights</h3>
          <p class="texts">Unless otherwise stated, all products, technologies, software, programs, data, and other information available on the Xiangchu platform—including but not limited to text, images, audio, video, graphics, layout design, and electronic documents—are owned by Xiangchu or its affiliated companies. All intellectual property rights (including copyrights, trademarks, patents, trade secrets, and other rights) are protected by law.</p>
          <p class="texts">Without prior written authorization from Xiangchu, no individual or entity may use, copy, reproduce, disseminate, display, mirror, upload, or download any content from the platform by any means (including automated tools such as robots or web crawlers).</p>
          <p class="texts">The Xiangchu logo and related names, marks, and branding elements are trademarks of Xiangchu and/or its affiliates. Unauthorized use is strictly prohibited.</p>
          <h3 class="titles">Limitation of Liability</h3>
          <p class="texts">The Xiangchu platform operates as an information service platform. Content such as company profiles, products, services, and solutions (including descriptions, contact details, images, and videos) are provided and uploaded by suppliers or members. Such parties shall bear full legal responsibility for the accuracy and legality of the information they provide.</p>
          <p class="texts">Reposted content (including forum posts) is intended solely for information sharing and does not imply endorsement or verification by Xiangchu.</p>
          <p class="texts">All content is provided for reference only. Any loss arising from reliance on or use of such information shall be borne solely by the user, and Xiangchu shall not be held liable.</p>
          <h3 class="titles">Intellectual Property Protection</h3>
          <p class="texts">Xiangchu respects intellectual property rights and opposes infringement. If any rights holder believes that content on the platform infringes upon their lawful rights, they may submit a written notice via email to <b>gossliu@foxmail.com</b>, and Xiangchu will promptly handle the matter upon receipt.</p>
          <h4 class="title">Privacy Policy</h4>
          <h3 class="titles">Overview</h3>
          <p class="texts">Xiangchu respects and protects user privacy. When you use our services, we will collect, use, store, and share your personal information in accordance with this Privacy Policy.</p>
          <p class="texts">This Policy explains:</p>
          <p class="texts">What information we collect</p>
          <p class="texts">How we use the information</p>
          <p class="texts">Your rights regarding your personal information</p>
          <p class="texts">By using our services, you consent to the lawful use and protection of your personal information as described herein.</p>
          <h3 class="titles">Scope of Application</h3>
          <p class="texts">This Privacy Policy applies to all services provided on the Xiangchu platform, including affiliated websites that do not have independent privacy policies.</p>
          <p class="texts">This Policy does not apply to services provided by third parties (e.g., suppliers on the platform). You should review their respective privacy policies.</p>
          <h3 class="titles">Information We Collect</h3>
          <p class="texts">1. Information You Provide</p>
          <p class="texts">Account registration information (e.g., username, phone number, email)</p>
          <p class="texts">Information submitted when using services (e.g., name, gender, company, job title, passport details, address)</p>
          <p class="texts">Information provided through customer service, surveys, or platform interactions</p>
          <p class="texts">2. Information Collected Automatically</p>
          <p class="texts">Device information (model, OS, identifiers)</p>
          <p class="texts">Location information (via GPS, Wi-Fi, etc.)</p>
          <p class="texts">Network and usage data (IP address, browser type, access time, browsing records)</p>
          <p class="texts">We may link data across devices to provide consistent services.</p>
          <p class="texts">3. Information from Third Parties</p>
          <p class="texts">We may receive information from affiliated companies or partners to improve services or ensure security, subject to applicable laws and your consent.</p>
          <h3 class="titles">How We Use Your Information</h3>
          <p class="texts">We use collected information to:</p>
          <p class="texts">Provide and improve services</p>
          <p class="texts">Deliver personalized recommendations or marketing content</p>
          <p class="texts">Prevent fraud, security risks, and illegal activities</p>
          <p class="texts">Combine data across services for enhanced experience</p>
          <p class="texts">Fulfill other purposes with your consent</p>
          <p class="texts">We may use anonymized data for commercial purposes without identifying individuals.</p>
          <h3 class="titles">Your Rights</h3>
          <p class="texts">You have the right to:</p>
          <p class="texts">Access, correct, or delete your personal information</p>
          <p class="texts">Modify privacy and security settings</p>
          <p class="texts">Withdraw consent</p>
          <p class="texts">Request a copy of your data</p>
          <p class="texts">We may require identity verification for security purposes.</p>
          <h3 class="titles">Information Sharing</h3>
          <p class="texts">We do not sell your personal information. We only share it in the following cases:</p>
          <p class="texts">With your consent</p>
          <p class="texts">With affiliated companies (with authorization)</p>
          <p class="texts">With third-party partners when necessary for services</p>
          <p class="texts">For legal or regulatory compliance</p>
          <p class="texts">To resolve disputes</p>
          <p class="texts">To prevent fraud or protect rights</p>
          <p class="texts">We only share necessary information and require recipients to comply with confidentiality obligations.</p>
          <h3 class="titles">Cookies</h3>
          <p class="texts">We use cookies and similar technologies to:</p>
          <p class="texts">Improve user experience</p>
          <p class="texts">Recognize user identity</p>
          <p class="texts">Enhance security</p>
          <p class="texts">You may manage or disable cookies via browser settings, but this may affect service functionality.</p>
          <h3 class="titles">Data Storage</h3>
          <p class="texts">Personal information is stored on servers within China unless otherwise permitted by law.</p>
          <p class="texts">We retain data only for as long as necessary, unless required by law or regulatory obligations.</p>
          <p class="texts">Upon termination of services, we will delete or anonymize your data within a reasonable timeframe.</p>
          <h3 class="titles">Data Security</h3>
          <p class="texts">We implement industry-standard security measures, including:</p>
          <p class="texts">Encryption</p>
          <p class="texts">Access control</p>
          <p class="texts">Internal data protection policies</p>
          <p class="texts">However, no system is completely secure. Users are advised to protect their account credentials.</p>
          <p class="texts">In case of data breaches, we will notify users promptly in accordance with legal requirements.</p>
          <h3 class="titles">Protection of Minors</h3>
          <p class="texts">Our services are primarily intended for adults. If you are under 18, you must use our services with guardian consent.</p>
          <p class="texts">Guardians may contact us regarding minors’ personal information.</p>
          <h3 class="titles">Policy Updates</h3>
          <p class="texts">This Policy is governed by the laws of the People’s Republic of China.</p>
          <p class="texts">We may update this Policy from time to time. Updated versions will be announced via the platform. Continued use of services constitutes acceptance of the updated Policy.</p>
          <p class="texts">Last updated: September 21, 2018</p>
          <h3 class="titles">Contact Us</h3>
          <p class="texts">If you have any questions, comments, or complaints, please contact us:</p>
          <p class="texts">Phone: 40088-18590</p>
          <p class="texts">We will respond within 15 working days after verifying your identity.</p>
        </div>
      `
    }
  }
}
